<template>
    <div>
        <a-row>
            <a-col>
                <span style="font-weight: bold;">{{ divider }}</span>
            </a-col>
            <a-col style="margin-left: auto;">
                <a-space>
                    <a-button v-if="drawer_button_text" :disabled="target_object[target_key] && edit_sheet || status_disable" @click="show_drawer = true, drawer_create_data = []" type="primary" size="large" style="margin: 4px">
                        <span class="material-symbols-outlined" style="font-size: 16px; margin-right: 4px">Add</span>
                        {{ drawer_button_text }}
                    </a-button>
                    <a-dropdown>
                        <template #overlay>
                            <a-menu @click="import_export_dropdown">
                                <a-menu-item key="1">
                                    <a-upload
                                        style="display: flex"
                                        v-model:file-list="import_fileList"
                                        :show-upload-list="false"
                                        name="file"
                                        method="GET"
                                        accept=".xlsx,.xls"
                                        @change="import_change_price_rate"
                                    >
                                        <a-button ref="import_file">
                                            <span class="material-symbols-outlined">publish</span>Import
                                        </a-button>
                                    </a-upload>
                                </a-menu-item>
                                <a-menu-item key="3">
                                    <a-button ref="import_file">
                                        <span class="material-symbols-outlined">download</span>Export
                                    </a-button>
                                </a-menu-item>
                            </a-menu>
                        </template>
                        <a-button style="display: flex" size="large">
                            <template #icon><span class="material-symbols-outlined">Settings</span></template>
                            ตัวเลือก
                        </a-button>
                    </a-dropdown>
                    <a-button @click="clear_table()" type="dashed">CLEAR</a-button>
                </a-space>
            </a-col>
        </a-row>
        <a-table :columns="table_columns" :data-source="target_object[target_key]" :pagination="false"
            :scroll="{ x: 'calc(100px + 50%)', y: '100%' }">
            <template #bodyCell="{ column, record, index }">
                <template v-if="column.key === 'index'">
                    {{ index + 1 }}
                </template>
                <template v-if="column.key === 'price_date'">
                    {{ record.price_date?.format('DD/MM/YYYY') }}
                </template>
                <template v-if="column.key === 'price_time'">
                    {{ record.price_time?.format('HH:mm') }}
                </template>
                <template v-if="column.key === 'selling_per_trip'">
                    {{ changeToDecimal(record.selling_per_trip) }}
                </template>
                <template v-if="column.key === 'car_price_amount'">
                    {{ changeToDecimal(record.car_price_amount) }}
                </template>
                <template v-if="column.key === 'part_id'">
                    {{ show_name_from_id(this.selectables['Part'], record.part_id) }}
                </template>
                <template v-if="column.key === 'distance'">
                    {{ record.distance_1 }} - {{ record.distance_2 }}
                </template>
                <template v-if="column.key === 'car_type_id'">
                    {{ carTypeList.find((data)=>data.id == record.car_type_id)?.name }}
                </template>
                <template v-if="column.key === 'file_name'">
                    <a @click="downloadFile(record.file, record.file_name)" @click.stop>
                        <span class="download-icon">
                            {{ record?.file_name }}
                        </span>
                    </a>
                </template>
                <template v-if="column.key === 'id'">
                    <a @click="go_edit(record, index)">
                        <span style="font-size: 18px" class="material-symbols-outlined">edit</span>
                    </a>

                    <a @click="go_remove(record.id, target_modelname, index)">
                        <span style="font-size: 18px" class="material-symbols-outlined">delete</span>
                    </a>
                </template>
            </template>
        </a-table>
        <a-drawer v-model:visible="show_drawer" @afterVisibleChange="onDrawerOpen" :title="drawer_title" :closable="true" :footer="null">
            <a-form :model="drawer_create_data" name="form" autocomplete="off" layout="vertical"
                @finish="drawer_create">
                <a-row :gutter="20">
                    <a-col :span="col_span"
                        v-for="({ placeholder, required, input_type, options, label_key, validate, modelname, accept ,col_span}, key_name) in drawer_fields">
                        <a-form-item :label="placeholder" :name="key_name"
                            :rules="required ? validate ? [{ required, validator: validateSelect }] : [{ required, message: `โปรดระบุ ${placeholder}` }] : null">
                            <div v-if="input_type == 'select'">
                                <a-select v-model:value="drawer_create_data[key_name]"
                                    @change="(value) => handleOtherChange(value, key_name)" show-search
                                    :placeholder="placeholder">
                                    <a-select-option v-for="option in options" :value="option.value">
                                        {{ option.label }}
                                    </a-select-option>
                                </a-select>
                                <a-modal v-model:visible="showOtherModal" :title="`ระบุ${placeholder}อื่นๆ`"
                                    @ok="handleModalOk" @cancel="handleModalCancel">
                                    <a-input v-model:value="otherInput" :placeholder="`ระบุ${placeholder}อื่นๆ`" />
                                </a-modal>
                            </div>
                            <a-checkbox-group v-else-if="input_type === 'checkbox_result'"
                                v-model="drawer_create_data[key_name]" :placeholder="placeholder">
                                <a-checkbox value="ผ่าน">ผ่าน</a-checkbox>
                                <a-checkbox value="ไม่ผ่าน">ไม่ผ่าน</a-checkbox>
                            </a-checkbox-group>
                            <a-date-picker v-else-if="input_type == 'date'" 
                                v-model:value="drawer_create_data[key_name]"
                                :placeholder="placeholder" style="display: flex;"
                            />
                            <a-time-picker v-else-if="input_type == 'time'"
                                v-model:value="drawer_create_data[key_name]"
                                :show-time="{ format: 'HH:mm' }"
                                format="HH:mm"
                                :placeholder="placeholder"
                                :minuteStep="1"
                                style="width: 100%;"
                            />
                            <div v-else-if="input_type == 'file'"
                                style="display: flex; flex-direction: column; align-items: flex-start; gap:1rem">
                                <div>{{ label }}</div>
                                <a v-if="drawer_create_data[key_name]" :href="drawer_create_data[key_name]"
                                    target="_blank" rel="doc">
                                    {{ drawer_create_data[`${key_name}_name`] }}
                                </a>
                                <a-upload v-else v-model:file-list="fileList" method="GET" :show-upload-list="false"
                                    :accept="accept ? accept : '*/*'" @change="upload_files($event, key_name)">
                                    <div style="display: flex; flex-direction: column; align-items: center;">
                                        <p class="ant-upload-drag-icon">
                                            <span class="material-symbols-outlined"
                                                style="font-size: 5rem;">upload_file</span>
                                        </p>
                                        อัพโหลดไฟล์
                                    </div>
                                </a-upload>
                                <a-button danger type="text" @click="(drawer_create_data[key_name] = '')"
                                    style="padding: 0; height: 18px;" v-if="drawer_create_data[key_name]">
                                    <span class="material-symbols-outlined">close</span>
                                </a-button>
                            </div>
                            <div v-else-if="key_name == 'distance_1'">
                                <a-row :gutter="0">
                                    <a-col :span="19">
                                        <a-input
                                            v-model:value="drawer_create_data[key_name]"
                                            :placeholder="placeholder"
                                            :type="input_type"
                                            style="width: 100%;"
                                        />
                                    </a-col>
                                    <a-col :span="5" style="text-align: center;">
                                        <span> - </span>
                                    </a-col>
                                </a-row>
                            </div>
                            <div v-else-if="key_name == 'start_place'">
                                    <vue-google-autocomplete
                                        :ref="key_name + selectedIndex"
                                        :id="key_name + selectedIndex"
                                        classname="form-control"
                                        :placeholder="placeholder"
                                        v-on:input="
                                            drawer_create_data[key_name] = $event.target.value
                                        "
                                        v-on:placechanged="
                                        select_stop_name($event, key_name)
                                        "
                                        types="establishment"
                                        country="th"
                                    >
                                    </vue-google-autocomplete>
                            </div>
                            <div v-else-if="key_name == 'end_place'">
                                    <vue-google-autocomplete
                                        :ref="key_name + selectedIndex"
                                        :id="key_name + selectedIndex"
                                        classname="form-control"
                                        :placeholder="placeholder"
                                        v-on:input="
                                            drawer_create_data[key_name] = $event.target.value
                                        "
                                        v-on:placechanged="
                                        select_stop_name($event, key_name)
                                        "
                                        types="establishment"
                                        country="th"
                                    >
                                    </vue-google-autocomplete>
                            </div>
                            <div v-else-if="key_name == 'car_type_id'">
                                <a-select
                                    style="width: 100%"
                                    v-model:value="drawer_create_data[key_name]"
                                    placeholder="ประเภทรถ"
                                >
                                    <a-select-option v-for="{ name, id } in carTypeList" :key="id" :value="id">
                                    {{ name }}
                                    </a-select-option>
                                </a-select>
                            </div>
                            <a-input v-else-if="input_type != 'none'" v-model:value="drawer_create_data[key_name]"
                                :placeholder="placeholder" :type="input_type" />
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row justify="end">
                    <a-col>
                        <a-button v-if="drawer_button_text" html-type="submit" type="primary" size="large"
                            style="margin: 4px;text-align: right">
                            <span class="material-symbols-outlined"
                                style="font-size: 16px;margin-right: 4px">Save</span>
                            บันทึกข้อมูล
                        </a-button>
                        <a-button v-else="drawer_button_text_edit" html-type="submit" type="primary" size="large"
                            style="margin: 4px;text-align: right">
                            <span class="material-symbols-outlined" style="font-size: 16px;margin-right: 4px">Add</span>
                            บันทึกข้อมูล
                        </a-button>
                    </a-col>
                </a-row>
            </a-form>
        </a-drawer>
    </div>
</template>

<script>
import Swal from 'sweetalert2'
import SystemService from '../api/SystemService'
import DriverInfo from '../api/DriverInfo';
import XLSX from "xlsx-js-style";
import { xlxsBase64toJson } from '@/components/helpers.js'
import { message } from 'ant-design-vue';
import VueGoogleAutocomplete from "vue-google-autocomplete";
import dayjs from 'dayjs';
import 'dayjs/locale/th';
import DriverService from '../api/DriverService';
import CarTypeService from '../api/CarTypeService';
import { el, er } from '@fullcalendar/core/internal-common';
import BookingService from '../api/BookingService';
import ProjectService from '../api/ProjectService';


export default {
    props: {
        divider: String,
        table_columns: Array,
        target_object: Object,
        target_key: String,
        target_modelname: String,
        drawer_title: String,
        drawer_fields: Object,
        data: Array,
        drawer_button_text: String,
        drawer_button_text_edit: String,
        businessTypeId: String,
    },
    name: 'table_create_drawer_project',
    data() {
        return {
            show_drawer: false,
            on_edit: false,
            drawer_create_data: {},
            selectables: {},
            selectedIndex: null,
            fileList: [],
            currentFieldKey: null,
            showOtherModal: false,
            otherInput: '',
            thaiToEnglishMap:{},
            import_fileList: [],
            priceRate: [],
            driverList:[],
            carList: [],
            carTypeList:[],
            time_period_list: [],
            time_type_list: [],
            originalDataDrawer: {},
            initialDate: null,
        }
    },
    components: {
        VueGoogleAutocomplete,
    },
    watch: {
        show_drawer(newVal) {
            if (newVal) {
                // เมื่อเปิด drawer เก็บค่าเดิมของ start_place
                this.originalDataDrawer = {
                    start_place: this.drawer_create_data.start_place,
                    end_place: this.drawer_create_data.end_place
                };
            } else {
                // ถ้าปิด drawer และยังไม่ได้กดบันทึก ให้คืนค่าเดิม
                if (!this.on_edit) {
                    this.drawer_create_data.start_place = this.originalDataDrawer.start_place;
                    this.drawer_create_data.end_place = this.originalDataDrawer.end_place;
                }
            }
        }
    },
    computed: {
    },
    methods: {
        changeToDecimal(amount) {
            if (typeof amount === "string" || typeof amount === "number") {
                return parseFloat(amount).toLocaleString('en-US');
            }
            return amount;
        },
        printCheck(data){
            console.log("Show",data)
        },
        validateSelect(rule, value) {
            if (!value && rule.field === 'time_type') {
                return Promise.reject(`โปรดระบุประเภทเวลางาน`)
            }
            if (!value && rule.field === 'time_period') {
                return Promise.reject(`โปรดระบุกะเวลางาน`)
            }

            if (rule.field === 'time_type') {
            const exists = this.time_type_list?.some(item => item?.name === value)
            return exists
                ? Promise.resolve()
                : Promise.reject(`ไม่พบ ${value} ในระบบ กรุณากรอกใหม่อีกครั้ง`)
            }

            if (rule.field === 'time_period') {
            const exists = this.time_period_list?.some(item => item?.name === value)
            return exists
                ? Promise.resolve()
                : Promise.reject(`ไม่พบ ${value} ในระบบ กรุณากรอกใหม่อีกครั้ง`)
            }

            return Promise.resolve()
        },
        async go_edit(record, index) {
            this.drawer_create_data = { ...record }
            this.on_edit = true
            this.show_drawer = true
            this.selectedIndex = index
        },
        onDrawerOpen() {
            this.$nextTick(() => {
                const startPlaceInput = document.getElementById('start_place' + this.selectedIndex);
                const endPlaceInput = document.getElementById('end_place' + this.selectedIndex);
                if (this.drawer_create_data.start_place != null||this.drawer_create_data.end_place != null) {
                    if(startPlaceInput){
                        startPlaceInput.value = this.drawer_create_data.start_place;
                    }
                    if(endPlaceInput){
                        endPlaceInput.value = this.drawer_create_data.end_place;
                    }
                }else{
                    startPlaceInput.value = '';
                    endPlaceInput.value = '';
                    this.on_edit = false;
                }
            });
        },
        clear_table(){
            Swal.fire({
                title: `คุณต้องการลบข้อมูลทั้งหมดนี้ใช่หรือไม่?`,
                text: "คุณจะไม่สามารถกู้คืนข้อมูลนี้ได้หากลบแล้ว!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'ใช่, ลบข้อมูลนี้!',
                cancelButtonText: 'ยกเลิก'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    if(this.target_object[this.target_key][0]?.id){
                        await ProjectService.deleteAllPriceRateByProjectId(this.target_object[this.target_key][0]?.project_id)
                    }
                    this.target_object[this.target_key] = [];
                    Swal.fire(
                        'ลบข้อมูลเรียบร้อย!',
                        'ข้อมูลของคุณถูกลบแล้ว',
                        'success'
                    )
                }
            })

        },
        async go_remove(id, type, index) {
            if (id) {
                Swal.fire({
                    title: `คุณต้องการลบข้อมูลนี้ใช่หรือไม่?`,
                    text: "คุณจะไม่สามารถกู้คืนข้อมูลนี้ได้หากลบแล้ว!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'ใช่, ลบข้อมูลนี้!',
                    cancelButtonText: 'ยกเลิก'
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        await SystemService.delete_all(type, id)
                        this.target_object[this.target_key].splice(index, 1)
                        Swal.fire(
                            'ลบข้อมูลเรียบร้อย!',
                            'ข้อมูลของคุณถูกลบแล้ว',
                            'success'
                        )
                    }
                })
            } else {
                Swal.fire({
                    title: `คุณต้องการลบข้อมูลนี้ใช่หรือไม่?`,
                    text: "คุณจะไม่สามารถกู้คืนข้อมูลนี้ได้หากลบแล้ว!",
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'ใช่, ลบข้อมูลนี้!',
                    cancelButtonText: 'ยกเลิก'
                }).then(async (result) => {
                    if (result.isConfirmed) {
                        this.target_object[this.target_key].splice(index, 1)
                        Swal.fire(
                            'ลบข้อมูลเรียบร้อย!',
                            'ข้อมูลของคุณถูกลบแล้ว',
                            'success'
                        )
                    }
                })
            }
        },
        async drawer_create(data) {
            const { id } = this.drawer_create_data;
            if (!this.on_edit) {
                if (!Array.isArray(this.target_object[this.target_key])) {
                    this.target_object[this.target_key] = [];
                }
                var isDuplicate = this.target_object[this.target_key].some(item => (item.start_place == data.start_place && item.end_place == data.end_place && item.car_type_id == data.car_type_id));
                if(this.businessTypeId == 4){
                    isDuplicate == false;
                }
                if (isDuplicate) {
                    Swal.fire(
                        'ข้อมูลซ้ำ!',
                        'ข้อมูลนี้มีอยู่แล้ว',
                        'error'
                    );
                    return;
                }
            }
            if (this.on_edit && this.selectedIndex != null) {
                if (!Array.isArray(this.target_object[this.target_key])) {
                    this.target_object[this.target_key] = [];
                }
                const filteredList = this.target_object[this.target_key].filter((_, index) => index !== this.selectedIndex);
                var isDuplicate
                if(this.businessTypeId != 4){
                    isDuplicate = filteredList.some(item => (item.start_place == data.start_place && item.end_place == data.end_place && item.car_type_id == data.car_type_id));
                }else{
                    //isDuplicate = filteredList.some(item => (item.start_place == data.start_place));
                    isDuplicate = false;
                }
                if (isDuplicate) {
                    Swal.fire(
                        'ข้อมูลซ้ำ!',
                        'ข้อมูลนี้มีอยู่แล้ว',
                        'error'
                    );
                    return;
                }
                this.target_object[this.target_key].some(item => {
                    const project = this.priceRate.find(project => project.project_id == item.project_id);
                    if (project) {
                        // console.log('item:', item.project_id);
                        // console.log('project:', project.project_id);
                        data.project_id = item.project_id;
                    } else {
                        console.log('Project not found for item:', item.project_id);
                    }
                });
                if (id) {
                    if (Array.isArray(this.target_object[this.target_key])) {
                        const filteredList = this.target_object[this.target_key].filter((_, index) => index !== this.selectedIndex);
                        const isDuplicate = filteredList.some(item => {
                            const priceRateItem = this.priceRate.find(project => project.id == item.id);
                            if(this.businessTypeId != 4){
                                return priceRateItem && (priceRateItem.start_place == data.start_place && priceRateItem.end_place == data.end_place && priceRateItem.car_type_id == data.car_type_id);
                            }else{
                                //return priceRateItem && (priceRateItem.start_place == data.start_place);
                                return false
                            }
                        });
                        if (isDuplicate) {
                            Swal.fire(
                                'ข้อมูลซ้ำ!',
                                'ข้อมูลนี้มีอยู่แล้ว',
                                'error'
                            );
                            return;
                        }
                    } else {
                        this.target_object[this.target_key] = [];
                    }
                    await SystemService.update_all(this.target_modelname, { data: data }, id);
                    Swal.fire(
                        'แก้ไขข้อมูลเรียบร้อย!',
                        'ข้อมูลของคุณถูกแก้ไขแล้ว',
                        'success'
                    ).then(() => {
                        window.location.reload();
                    });
                } else {
                    this.target_object[this.target_key][this.selectedIndex] = data;
                }
            } else {
                this.target_object[this.target_key] ? this.target_object[this.target_key].push(data) :
                    this.target_object[this.target_key] = [data];
            }
            this.drawer_create_data = {};
            this.show_drawer = false;
            this.on_edit = false;
            this.selectedIndex = null;
            this.show_drawer = false;
        },
        async get_default_fields() {
            // console.log("this.drawer_fields", this.drawer_fields)
            for (var key in this.drawer_fields) {
                const { input_type, modelname } = this.drawer_fields[key]
                if (input_type == 'select') {
                    this.selectables[modelname] = await SystemService.get_all(modelname)
                }
            }
            this.priceRate = await SystemService.get_all('PriceRate');
            this.driverList = await DriverService.getDriverByCompany();
            this.carList = await SystemService.get_all('Car');
            this.carTypeList = await CarTypeService.getCarTypeByCompany();
            this.time_period_list = await BookingService.getTimePeriodAll();
            this.time_type_list = await BookingService.getTimeTypeAll();
        },
        show_name_from_id(array, id) {
            return array.find(el => el.id == id)?.name
        },
        upload_files(e, key) {
            try {
                if (e.file.status != 'remove') {
                    this.getBase64(e.file.originFileObj, key)
                    if (e.file.status == 'uploading' && !this.isLoading) {
                        this.$message.loading('กำลังอัปโหลดไฟล์...');
                        this.isLoading = true;
                    }
                    if (e.file.status == 'error') {
                        this.$message.success('อัปโหลดไฟล์สำเร็จ')
                        this.isLoading = false;
                    }
                    return true
                }else{
                    const vue = this
                    vue.drawer_create_data[`${key}_name`] = null
                }
            } catch (error) {
                console.log(error)
            }
        },
        async getBase64(file, key) {
            if (key) {
                const vue = this
                var reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onload = function () {
                    vue.drawer_create_data[key] = reader.result
                    vue.drawer_create_data[`${key}_name`] = file.name
                };
            } else {
                return await new Promise((resolve, reject) => {
                    if (file) {
                        if (typeof file == 'string') {
                            resolve(file)
                        } else {
                            const reader = new FileReader();
                            reader.readAsDataURL(file);
                            reader.onload = () => resolve(reader.result);
                            reader.onerror = error => reject(error);
                        }
                    }
                });
            }
        },
        async select_stop_name(e, target, is_car) {
            const { latitude, longitude } = e;
            if (target && !is_car) {
                this.drawer_create_data[target] = document.getElementById(target+this.selectedIndex).value.split(",")[0];
            } else if (is_car) {
                this.drawer_create_data[target]  = document
                .getElementById(target)
                .value.split(",")[0];
            } else {
                this.add_stop.lat = latitude;
                this.add_stop.lng = longitude;
                this.add_stop.name = document.getElementById("map").value.split(",")[0];
            }
        },
        async getBase64ImageFromURL(url) {
            const res = await fetch(url, {
                method: 'GET',
                mode: 'cors',
                cache: 'no-cache',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/json'
                },
                redirect: 'follow',
                referrerPolicy: 'no-referrer'
            });
            const blob = await res.blob();
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => {
                    resolve(reader.result);
                };
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        },
        async export_file() {
            this.$message.loading({ content: "กำลังโหลด...", key: "loading" });

            // Define headers for the Excel file
            var headersColumn
            if(this.businessTypeId == 4){
                headersColumn = [
                    { header: "ต้นทาง(สายงาน)", key: "start_place" }, 
                    { header: "ประเภทเวลางาน\n(ต้องมีในระบบ)", key: "time_type" },
                    { header: "กะเวลางาน\n(ต้องมีในระบบ)", key: "time_period" },  
                    // { header: "วันที่\n(DD/MM/YYYY)", key: "price_date" }, 
                    // { header: "เวลา\n(HH:MM)", key: "price_time" }, 
                    // { header: "ทะเบียนรถ\n(ต้องมีในระบบ)", key: "plate_no" }, 
                    // { header: "คนขับ\n(ต้องมีในระบบ)", key: "driver_name" },
                    { header: "ราคาวางบิลลูกค้า", key: "selling_per_trip" },  
                    { header: "ราคาว่าจ้างรถ", key: "car_price_amount" }, 
                    { header: "ระยะทาง (กิโลเมตร)", key: "distance_kilo" }, 
                ]
            }else{
                headersColumn = [
                    { header: "ต้นทาง", key: "start_place" }, 
                    { header: "ปลายทาง", key: "end_place" }, 
                    { header: "คำอธิบาย", key: "descriptions" },
                    { header: "ประเภทรถ", key: "car_type_id" },  
                    { header: "ราคาวางบิลลูกค้า", key: "selling_per_trip" },  
                    { header: "ราคาว่าจ้างรถ", key: "car_price_amount" },
                    { header: "จำนวนชั่วโมงรวม", key: "total_hours" }, 
                    { header: "ระยะทางรวม", key: "total_distance" }, 
                ];
            }

            const workBook = XLSX.utils.book_new();
            const workSheet = XLSX.utils.aoa_to_sheet([headersColumn.map(h => h.header)]);

            headersColumn.forEach((header, index) => {
                const cellAddress = XLSX.utils.encode_cell({ c: index, r: 0 });
                let cell = workSheet[cellAddress];
                if (!cell) {
                    cell = { v: "" };
                    workSheet[cellAddress] = cell;
                }

                const bgColor = [
                    "ต้นทาง", 
                    "ปลายทาง", 
                    "ประเภทรถ", 
                    "จำนวนชั่วโมงรวม", 
                    "ระยะทางรวม",
                    "ราคาวางบิลลูกค้า",
                    "ราคาว่าจ้างรถ",
                    "ต้นทาง(สายงาน)",
                    "ประเภทเวลางาน\n(ต้องมีในระบบ)",
                    "กะเวลางาน\n(ต้องมีในระบบ)",  
                    "วันที่\n(DD/MM/YYYY)", 
                    "เวลา\n(HH:MM)", 
                    "ทะเบียนรถ\n(ต้องมีในระบบ)", 
                    "คนขับ\n(ต้องมีในระบบ)",                
                ].includes(header.header)
                    ? "#f0b474"  
                    : "#ffe4d4";  

                cell.s = {
                    font: { bold: true },
                    fill: { fgColor: { rgb: bgColor.replace("#", "") } },
                    border: {
                        bottom: { style: "thin" },
                        right: { style: "thin" },
                        left: { style: "thin" },
                        top: { style: "thin" },
                    },
                    alignment: { horizontal: "center", vertical: "center" , wrapText: true},
                };
            });


            workSheet['!cols'] = headersColumn.map(() => ({ wch: 25 }));

            XLSX.utils.book_append_sheet(workBook, workSheet, "Report");

            XLSX.writeFile(workBook, "PriceRate.xlsx");
            this.$message.success({ content: "สร้างไฟล์สำเร็จ", key: "loading" });
        },
        import_export_dropdown(e) {
            const { key } = e
            if (key == '1') {
                
            } else if (key == '2') {
                this.export_file()
            } else if (key == '3') {
                this.export_file()
            } 
        },
        import_change_price_rate(event, field) {
            const priceRate = this.priceRate;
            // console.log('yyy',priceRate)
            const file = event.file.originFileObj;

            const validFileTypes = ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel'];
            if (!validFileTypes.includes(file.type)) {
                message.error({ content: 'โปรดอัปโหลดไฟล์ Excel เท่านั้น', key: 'import', duration: 1.5 });
                return;
            }

            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = async () => {
                var result = xlxsBase64toJson(reader.result.split(',')[1]);
                if(this.target_key == 'priceRate'){
                    if(this.businessTypeId==4){
                        this.thaiToEnglishMap = {
                            "ต้นทาง(สายงาน)": "start_place",
                            "ประเภทเวลางาน(ต้องมีในระบบ)": "time_type",
                            "กะเวลางาน(ต้องมีในระบบ)": "time_period",
                            "วันที่(DD/MM/YYYY)": "price_date",
                            "เวลา(HH:MM)": "price_time",
                            "ทะเบียนรถ(ต้องมีในระบบ)": "plate_no",
                            "คนขับ(ต้องมีในระบบ)": "driver_name",
                            "ราคาวางบิลลูกค้า": "selling_per_trip",
                            "ราคาว่าจ้างรถ": "car_price_amount",
                            "ระยะทาง(กิโลเมตร)": "distance_kilo", 
                        };
                    }else{
                        this.thaiToEnglishMap = {
                            "ต้นทาง": "start_place",
                            "ปลายทาง": "end_place",
                            "คำอธิบาย": "descriptions",
                            "ประเภทรถ": "car_type_id",
                            "ราคาวางบิลลูกค้า": "selling_per_trip",
                            "ราคาว่าจ้างรถ": "car_price_amount",
                            "จำนวนชั่วโมงรวม": "total_hours",
                            "ระยะทางรวม": "total_distance",
                        };
                    }
                    result = this.translateJSON(result);
                }
                message.loading({ content: 'กำลังนำเข้าข้อมูล...', key: 'import', duration: 0 });
                if (result && event.file.status === 'done') {
                    var resultArray = Array.isArray(result) ? result : Object.values(result);
                    const existingData = this.target_object[this.target_key] || [];
                    var wrongDate = false;
                    var wrongTime = false;
                    var wrongDriver = false;
                    var wrongCar = false;
                    var blankDriver = false;
                    var blankCar = false;
                    if(this.businessTypeId == 4){
                        resultArray.forEach(item => {
                            // if (item.price_time && !isNaN(item.price_time)) {
                            //     const hours = Math.floor(item.price_time * 24);
                            //     const minutes = Math.round((item.price_time * 24 * 60) % 60);
                            //     item.price_time = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
                            //     item.price_time = dayjs(item.price_time, 'HH:mm');
                            // } else {
                            //     wrongTime = true;
                            // }
                            // if(item.price_date){
                            //     const excelBaseDate = dayjs('1899-12-30');
                            //     if(!this.isValidDDMMYYYY(item.price_date)){
                            //         wrongDate = true;
                            //     }else if (typeof item.price_date === 'string') {
                            //         const [day, month, year] = item.price_date.split('/');
                            //         item.price_date = dayjs(`${year}-${month}-${day}`, 'YYYY-MM-DD');
                            //     } else if (typeof item.price_date === 'number') {
                            //         item.price_date = excelBaseDate.add(item.price_date, 'day');
                            //     } else if (item.price_date instanceof Date) {
                            //         item.price_date = dayjs(item.price_date);
                            //     }
                            // }
                            // const isMatch = this.driverList.some(driver => 
                            //     `${driver.firstname}${driver.lastname}`.replace(/\s+/g, '') == 
                            //     item.driver_name?.replace(/\s+/g, '')
                            // );
                            // if (!isMatch && item.driver_name) {
                            //     wrongDriver = true;
                            //     item.driver_name = "";
                            // } else if(!item.driver_name){
                            //     blankDriver = true;
                            // }
                            // const isMatchCar = this.carList.some(car => 
                            //     `${car.plate_no}`.replace(/\s+/g, '') == 
                            //     item.plate_no?.replace(/\s+/g, '')
                            // );
                            // if (!isMatchCar && item.plate_no) {
                            //     wrongCar = true;
                            //     item.plate_no = "";
                            // } else if(!item.plate_no){
                            //     blankCar = true;
                            // }
                        });
                    }else {
                        resultArray.forEach(item => {
                            const isMatch = this.carTypeList.some(carType => 
                                `${carType.name}`.replace(/\s+/g, '') == 
                                item.car_type_id?.replace(/\s+/g, '')
                            );
                            if (!isMatch) {
                                item.car_type_id = null;
                            }else{
                                item.car_type_id = this.carTypeList.find((carType)=> carType.name == item.car_type_id).id
                            }
                        });
                    }
                    const uniqueResultArray = resultArray.filter((newItem, index, self) =>
                        {
                            return this.businessTypeId == 4 ? 
                            // index == self.findIndex((item) =>
                            //     item.start_place === newItem.start_place
                            // )
                            true
                            : index == self.findIndex((item) =>
                                item.start_place === newItem.start_place && item.end_place == newItem.end_place && item.car_type_id == newItem.car_type_id
                            )
                        }
                    );
                    const duplicates = uniqueResultArray.filter((newItem, index) => {
                        const duplicateInSystem = existingData.some(existingItem => {
                            return this.businessTypeId == 4
                            ? (
                                existingItem.start_place == newItem.start_place &&
                                existingItem.time_type == newItem.time_type &&
                                existingItem.time_period == newItem.time_period &&
                                // dayjs(existingItem.price_date).isSame(dayjs(newItem.price_date), 'day') &&
                                // dayjs(existingItem.price_time).isSame(dayjs(newItem.price_time), 'minute') &&
                                // existingItem.plate_no == newItem.plate_no &&
                                // existingItem.driver_name == newItem.driver_name &&
                                existingItem.selling_per_trip == newItem.selling_per_trip &&
                                existingItem.car_price_amount == newItem.car_price_amount
                                )
                            : (
                                existingItem.start_place == newItem.start_place &&
                                existingItem.end_place == newItem.end_place &&
                                existingItem.car_type_id == newItem.car_type_id
                                );
                        });

                        const duplicateInFile = uniqueResultArray.some((item, i) => {
                            if (i === index) return false; // skip self

                            return this.businessTypeId == 4
                            ? (
                                item.start_place == newItem.start_place &&
                                item.time_type == newItem.time_type &&
                                item.time_period == newItem.time_period &&
                                // dayjs(item.price_date).isSame(dayjs(newItem.price_date), 'day') &&
                                // dayjs(item.price_time).isSame(dayjs(newItem.price_time), 'minute') &&
                                // item.plate_no == newItem.plate_no &&
                                // item.driver_name == newItem.driver_name &&
                                item.selling_per_trip == newItem.selling_per_trip &&
                                item.car_price_amount == newItem.car_price_amount
                                )
                            : (
                                item.start_place == newItem.start_place &&
                                item.end_place == newItem.end_place &&
                                item.car_type_id == newItem.car_type_id
                                );
                        });

                        return duplicateInSystem || duplicateInFile;
                    });


                    const nonDuplicates = uniqueResultArray.filter(newItem => 
                        !existingData.some(existingItem => 
                            {   
                                return this.businessTypeId == 4 
                                ?   //(existingItem.start_place == newItem.start_place)
                                false
                                :   (existingItem.start_place == newItem.start_place && existingItem.end_place == newItem.end_place && existingItem.car_type_id == newItem.car_type_id)
                            }
                        )
                    );
                    if (duplicates.length > 0) {
                        Swal.fire({
                            title: `<span style="font-weight:bold; font-size:16px;">พบ 1 ปัญหาที่ต้องแก้ไขก่อนนำเข้า\n กรุณาตรวจสอบและอัปโหลดใหม่อีกครั้ง</span>`,
                            html: `<div style="text-align: left;"> 1. ข้อมูลซ้ำกับข้อมูลในไฟล์หรือในระบบ </div>`,
                            icon: "error",
                            showCancelButton: true,
                            confirmButtonColor: "#3085d6",
                            confirmButtonText: "ยืนยัน",
                            cancelButtonColor: "#d33",
                            cancelButtonText: "ยกเลิก",
                        }).then(async (result) => {
                            message.error({ content: 'นำเข้าข้อมูลไม่สำเร็จ!', key: 'import', duration: 1.5 });
                        });
                        return
                    }
                    if (nonDuplicates.length > 0) {
                        try {
                                const errorSet = new Set();
                                const errors = [];

                                const addErrorOnce = (msg) => {
                                    if (!errorSet.has(msg)) {
                                        errorSet.add(msg);
                                        errors.push(msg);
                                    }
                                };
                                
                                if(wrongDate){
                                    addErrorOnce('คอลัมน์ “วันที่” รูปแบบไม่ถูกต้องกรุณาใช้รูปแบบ DD/MM/YYYY');
                                }
                                if(wrongTime){
                                    addErrorOnce('คอลัมน์ “เวลา” รูปแบบไม่ถูกต้องกรุณาใช้รูปแบบ HH:MM (เช่น 08:30)');
                                }
                                if(wrongDriver){
                                    addErrorOnce('คอลัมน์ “คนขับ” มีชื่อคนขับที่ไม่ถูกต้องหรือไม่มีในระบบ');
                                }
                                if(wrongCar){
                                    addErrorOnce('คอลัมน์ “ทะเบียนรถ” มีทะเบียนรถที่ไม่ถูกต้องหรือไม่มีในระบบ');
                                }
                                if(blankDriver){
                                    addErrorOnce('คอลัมน์ “คนขับ” ไม่สามารถเว้นว่างได้!');
                                }
                                if(blankCar){
                                    addErrorOnce('คอลัมน์ “ทะเบียนรถ” ไม่สามารถเว้นว่างได้!');
                                }
                                for (const item of nonDuplicates) {
                                    if (!item.start_place) {
                                        addErrorOnce('คอลัมน์ “ต้นทาง (สายงาน)” ไม่สามารถเว้นว่างได้!');
                                    }

                                    if (this.businessTypeId !== 4 && !item.end_place) {
                                        addErrorOnce('คอลัมน์ “ปลายทาง (สายงาน)” ไม่สามารถเว้นว่างได้!');
                                    }

                                    if (this.businessTypeId !== 4 && !item.car_type_id) {
                                        addErrorOnce('คอลัมน์ “ประเภทรถ” ไม่สามารถเว้นว่างได้!');
                                    }

                                    if (this.businessTypeId === 4) {
                                        if (!item.time_type) {
                                            addErrorOnce('คอลัมน์ “ประเภทเวลางาน” ไม่สามารถเว้นว่างได้!');
                                        } else if (!this.time_type_list.some(ttl => ttl.name === item.time_type)) {
                                            addErrorOnce('คอลัมน์ “ประเภทเวลางาน” ไม่ถูกต้องต้องเป็นค่าที่ระบบกำหนดเท่านั้น!');
                                        }

                                        if (!item.time_period) {
                                            addErrorOnce('คอลัมน์ “กะเวลางาน” ไม่สามารถเว้นว่างได้!');
                                        } else if (!this.time_period_list.some(tpt => tpt.name === item.time_period)) {
                                            addErrorOnce('คอลัมน์ “กะเวลางาน” ไม่ถูกต้องต้องเป็นค่าที่ระบบกำหนดเท่านั้น!');
                                        }

                                        // if (!item.price_date) {
                                        //     addErrorOnce('คอลัมน์ “วันที่” ไม่สามารถเว้นว่างได้!');
                                        // }

                                        // if (!item.price_time) {
                                        //     addErrorOnce('คอลัมน์ “เวลา” ไม่สามารถเว้นว่างได้!');
                                        // }

                                        // if (!item.plate_no && wrongCar == false) {
                                        //     addErrorOnce('คอลัมน์ “ทะเบียนรถ” ไม่สามารถเว้นว่างได้!');
                                        // }

                                        // if (!item.driver_name && wrongDriver == false) {
                                        //     addErrorOnce('คอลัมน์ “คนขับ” ไม่สามารถเว้นว่างได้!');
                                        // }
                                    }

                                    if (item.selling_per_trip == null || isNaN(item.selling_per_trip)) {
                                        addErrorOnce('คอลัมน์ “ราคางานลูกค้า” ต้องเป็นตัวเลขและไม่สามารถเว้นว่างได้!');
                                    }

                                    if (item.car_price_amount == null || isNaN(item.car_price_amount)) {
                                        addErrorOnce('คอลัมน์ “ราคาว่าจ้างรถ” ต้องเป็นตัวเลขและไม่สามารถเว้นว่างได้!');
                                    }

                                    if (this.businessTypeId !== 4 && !item.total_hours) {
                                        addErrorOnce('คอลัมน์ “จำนวนชั่วโมงรวม” ไม่สามารถเว้นว่างได้!');
                                    }

                                    if (this.businessTypeId !== 4 && !item.total_distance) {
                                        addErrorOnce('คอลัมน์ “ระยะทางรวม” ไม่สามารถเว้นว่างได้!');
                                    }
                                }
                                if(errors.length > 0){
                                    Swal.fire({
                                        title: `<span style="font-weight:bold; font-size:16px;">พบ ${errors.length} ปัญหาที่ต้องแก้ไขก่อนนำเข้า\n กรุณาตรวจสอบและอัปโหลดใหม่อีกครั้ง</span>`,
                                        html: `<div style="text-align: left;"> ${errors.map((err,idx) => {
                                            const messages = (`${idx + 1}.${err}`);
                                            return messages;
                                        }).join('<br/>')}
                                        </div>`,
                                        icon: "error",
                                        showCancelButton: true,
                                        confirmButtonColor: "#3085d6",
                                        confirmButtonText: "ยืนยัน",
                                        cancelButtonColor: "#d33",
                                        cancelButtonText: "ยกเลิก",
                                    }).then(async (result) => {
                                        message.error({ content: `นำเข้าข้อมูลไม่สำเร็จ!`, key: 'import', duration: 1.5 });
                                    });
                                }else if (this.target_object[this.target_key]) {
                                    Swal.fire({
                                        title: `<span style="font-weight:bold; font-size:16px;">คุณต้องการนำเข้าข้อมูล ${nonDuplicates?.length}<br>ใบงานที่ถูกต้องใช่หรือไม่?</span>`,
                                        icon: "success",
                                        showCancelButton: true,
                                        confirmButtonColor: "#3085d6",
                                        confirmButtonText: "ยืนยัน",
                                        cancelButtonColor: "#d33",
                                        cancelButtonText: "ยกเลิก",
                                    }).then(async (action) => {
                                        if (action.isConfirmed) {
                                            message.success({ content: `นำเข้าข้อมูลสำเร็จ!`, key: 'import', duration: 1.5 });
                                            this.target_object[this.target_key].push(...nonDuplicates);
                                        }else{
                                            message.error({ content: `ยกเลิกนำเข้าข้อมูล!`, key: 'import', duration: 1.5 });
                                        }
                                    });
                                } else {
                                    Swal.fire({
                                        title: `<span style="font-weight:bold; font-size:16px;">คุณต้องการนำเข้าข้อมูล ${nonDuplicates?.length}<br>ใบงานที่ถูกต้องใช่หรือไม่?</span>`,
                                        icon: "success",
                                        showCancelButton: true,
                                        confirmButtonColor: "#3085d6",
                                        confirmButtonText: "ยืนยัน",
                                        cancelButtonColor: "#d33",
                                        cancelButtonText: "ยกเลิก",
                                    }).then(async (action) => {
                                        if (action.isConfirmed) {
                                            message.success({ content: `นำเข้าข้อมูลสำเร็จ!`, key: 'import', duration: 1.5 });
                                            this.target_object[this.target_key] = [...nonDuplicates];
                                        }else{
                                            message.error({ content: `ยกเลิกนำเข้าข้อมูล!`, key: 'import', duration: 1.5 });
                                        }
                                    });
                                }

                        } catch (error) {
                            console.error('Error importing data:', error);
                            message.error({ content: 'เกิดข้อผิดพลาดในการนำเข้าข้อมูล', key: 'import', duration: 1.5 });
                        }
                    } else {
                        message.error({ content: 'ไม่มีข้อมูลใหม่ที่สามารถนำเข้าได้!', key: 'import', duration: 1.5 });
                    }
                } else {
                    message.error({ content: 'นำเข้าข้อมูลไม่สำเร็จ!', key: 'import', duration: 1.5 });
                }
                document.querySelector("input[type='file']").value = '';
            };

            reader.onerror = () => {
                message.error({ content: 'เกิดข้อผิดพลาดในการอ่านไฟล์', key: 'import', duration: 1.5 });
            };
        },
        isValidHHMM(timeStr) {
            if (typeof timeStr !== "string") return false;

            const regex = /^([01][0-9]|2[0-3]):[0-5][0-9]$/;
            if (!regex.test(timeStr)) return false;

            return true;
        },
        isValidDDMMYYYY(dateStr) {
            if (typeof dateStr !== "string") return true;
            
            const regex = /^(0?[1-9]|[12][0-9]|3[01])\/(0?[1-9]|1[0-2])\/\d{4}$/;
            if (!regex.test(dateStr)) return false;
            const [day, month, year] = dateStr.split("/").map(Number);
            const date = new Date(year, month - 1, day);      
            return (
                date.getFullYear() === year &&
                date.getMonth() === month - 1 &&
                date.getDate() === day
            );
        },
        normalizeKey(key) {
            return key
                .toString()
                .replace(/[\r\n\t]/g, "")
                .replace(/\s+/g, "")
                .trim();
        },
        translateJSON(json) {
            const translated = {};

            for (const key in json) {
                const normalizedKey = this.normalizeKey(key);
                const translatedKey = this.thaiToEnglishMap[normalizedKey] || normalizedKey
                const value = json[key];

                if (typeof value === 'object' && value !== null) {
                    translated[translatedKey] = this.translateJSON(value);
                } else {
                    translated[translatedKey] = value;
                }
            }

            return translated;
        },
        downloadFile(url, fileName) {
            fetch(url)
                .then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.blob();
                })
                .then(blob => {
                    const link = document.createElement('a');
                    link.href = window.URL.createObjectURL(blob);
                    link.download = fileName || 'default_filename.pdf'; // Set default filename if fileName is not valid
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(link.href);
                })
                .catch(error => {
                    console.error('Error downloading file:', error);
                });
        },
        handleOtherChange(value, key) {
            if (value === 'OTHER') {
                this.currentFieldKey = key;
                this.showOtherModal = true;
            }
        },
        handleModalOk() {
            this.drawer_create_data[this.currentFieldKey] = this.otherInput;
            this.showOtherModal = false;
            this.otherInput = '';
        },
        handleModalCancel() {
            this.showOtherModal = false;
            this.otherInput = '';
        },
    },

    async mounted() {
        await this.get_default_fields()
    }
}

</script>

<style scoped>
.ant-row {
    margin: 0
}
</style>